import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-add-resolution-orders-popup',
    templateUrl: './add-resolution-orders-popup.component.html',
    styleUrls: ['./add-resolution-orders-popup.component.scss'],
    standalone: false // NOSONAR
})
export class AddResolutionOrdersPopupComponent implements OnInit {
  resolutionId: any;

  constructor(public dialogRef: MatDialogRef<AddResolutionOrdersPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dataStore: any,) { }

  ngOnInit(): void {
   this.resolutionId=this.dataStore.resolutionId;
  
  }

  close() {
    this.dialogRef.close();
  }
  onProceed() {
    localStorage.setItem('resolutionId', this.resolutionId);  
    this.dialogRef.close('proceed');
  }
}
